import { readTodoList } from '@erikdakoda/todo/ai-tools/readTodoList';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(readTodoList);
